import _ from "lodash";
import { HostFamilyBase } from "../HostFamilyBase";

export class InterestedFamilyController extends HostFamilyBase {

    hf: any;
    isOnlineOrAwaiting: boolean;
    isToBeMatch: boolean;
    isRematch: boolean;
    isActiveApp: boolean;
    isPlacedOrActive: boolean;
    isPlaced: boolean;
    interestedFamiliesRequestStatus: string;
    pndMatch: boolean;

    profilePhoto;
    photos;
    specialNeedsOrMedicalCondition;

    disableLikeButton: boolean;

    static override $inject = ['$scope', '$sce', '$uibModal', '$state', '$window', 'dialogs', 'applicationId', 'hostFamilyId', 'PlacementMatchesDetails', 'InterestedHostFamiliesDetails', 'applicationObservable', '$stateParams', 'Auth']
    constructor($scope: angular.IScope, $sce, $uibModal, $state, private $window, private dialogs, applicationId, public hostFamilyId, public PlacementMatchesDetails, InterestedHostFamiliesDetails, applicationObservable, private $stateParams, private Auth) {
        super($uibModal, InterestedHostFamiliesDetails, $state, applicationId)

        

        applicationObservable.subscribe(applicationInstance => {
            this.isToBeMatch = (applicationInstance.status === 'TBM');
            this.isRematch = (applicationInstance.status === 'REM');
            this.isActiveApp = (applicationInstance.status === 'ACT');
            this.isPlaced = (applicationInstance.status === 'PLC');
            this.isOnlineOrAwaiting = (applicationInstance.status === 'OLA' || applicationInstance.status === 'AWA');
            this.isPlacedOrActive = (applicationInstance.status === 'PLC' || applicationInstance.status === 'ACT');

            if (this.isOnlineOrAwaiting || this.isToBeMatch) {
                PlacementMatchesDetails.getMatches({ applicationId: applicationId, status: 'PND' }).$promise.then((matches) => {
                    this.pndMatch = matches && matches.length > 0;
                });
            }

            if (this.isPlacedOrActive || this.isToBeMatch || this.isRematch) {
                this.loadIntrestedFamilies();
            }  
        })  
    }

    loadIntrestedFamilies() {
        this.interestedFamiliesRequestStatus = 'loading';
        this.hf = undefined;

        this.InterestedHostFamiliesDetails.getDefault({
            applicationId: this.applicationId, 
            hostFamilyId: this.hostFamilyId
        })
            .$promise
            .then((result) => {
                this.interestedFamiliesRequestStatus = 'completed';
                this.hf = result;

                this.$window.document.title = result.name;

                this.photos = _.orderBy(result.documents, ['documentTypeCode', 'isProfile', 'documentID'], ['desc', 'desc', 'desc']);
                this.profilePhoto = this.photos.shift();
                this.specialNeedsOrMedicalCondition = result.members.some(m => m.specialNeeds || m.medicalCondition);

                if (!this.hf.interestId) {
                    this.InterestedHostFamiliesDetails.limits({ applicationId: this.applicationId })
                        .$promise
                        .then((limits) => {
                            this.disableLikeButton = limits.maxAPSNTCount > limits.currentAPSNT;
                        })
                }
            }, () => {
                this.interestedFamiliesRequestStatus = 'failed';
            });
    }

    selectedProposal(hfData){

        this.$stateParams.proposalId = hfData.proposalId;
        this.$stateParams.photosUrl = hfData.photosURL;
        this.$stateParams.essayUrl = hfData.essayURL;
        this.$stateParams.email = hfData.email;

        var param = {
            proposalId: hfData.proposalId,
            photosUrl: hfData.photosURL,
            essayUrl: hfData.essayURL,
            email: hfData.email,
            requestId: hfData.requestId,
            hostFamilyId: hfData.hostFamilyId
        }
        if (this.Auth.user.isApplicant) {
            this.$state.go('app.hostFamilies.hostFamilyDocuments', param);
        } else {
            this.$state.go('app.applications.hostFamilies.hostFamilyDocuments', param);
        }

    }

    interested(hf) {
        this.openFeedbackDialog(hf, true);
    }

    notInterested(hf) {
        this.openFeedbackDialog(hf, false);
    }

    override openFeedbackDialog(hf, intrested: boolean) {

        super.openFeedbackDialog(hf, intrested)
            .result
            .then(() => {
                this.loadIntrestedFamilies();
            });
    }

    showPhoto(document) {
        this.$uibModal.open({
            templateUrl: 'areas/hostFamilies/interestedFamilyPhotoModal/interestedFamilyPhotoModal.html',
            controller: 'InterestedFamilyPhotoModalController as $ctrl',
            backdrop: false,
            size: 'lg',
            resolve: {
                applicationId: () => this.applicationId,
                documentID: () => document.documentID,
                documents: () => this.hf.documents.filter((d) => d.documentTypeCode == 'PHO').map((d) => {
                    return { documentID: d.documentID };
                })
            }
        })
    }
}

angular
    .module('app')
    .controller('InterestedFamilyController', InterestedFamilyController)
